import { combineReducers } from 'redux';

import accessRequestHistoryReducer from './ars';
import bulkActionReducer from './bulkaction';
import certsExportReducer from './certsexport';
import coreReducer from './core';
import globalReducer from './global';
import lineActionsReducer from './lineactions';
import linearProgressBarReducer from './linearprogressbar';
import personalizationReducer from './personalization';
import reviewAndSubmitReducer from './reviewandsubmit';
import saviCompanionReducer from './savicompanion';
import sidePanelReducer from './sidepanel';
import tabsReducer from './tabs';
import viewControlsReducer from './viewcontrols';

const certDetailsReducer = combineReducers({
  accessRequestHistory: accessRequestHistoryReducer,
  bulkAction: bulkActionReducer,
  certsExport: certsExportReducer,
  core: coreReducer,
  global: globalReducer,
  lineActions: lineActionsReducer,
  personalization: personalizationReducer,
  progressBreakdowndetails: linearProgressBarReducer,
  reviewAndSubmit: reviewAndSubmitReducer,
  saviCompanion: saviCompanionReducer,
  sidePanel: sidePanelReducer,
  tabs: tabsReducer,
  viewControls: viewControlsReducer,
});

export default certDetailsReducer;
